import { render, staticRenderFns } from "./ChangePasswordEmployee.vue?vue&type=template&id=23e4b823&scoped=true&"
import script from "./ChangePasswordEmployee.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordEmployee.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordEmployee.vue?vue&type=style&index=0&id=23e4b823&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e4b823",
  null
  
)

export default component.exports